export function normalizeDateTime(mydate) {
  if (mydate === null || mydate === undefined) {
    return null;
  }
  const utcplus8date = new Date(mydate).setHours(
    new Date(mydate).getHours() + 8
  );
  const date = new Date(utcplus8date);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  let year = date.getFullYear();
  let month = date.getMonth();
  let day = date.getDate().toString().padStart(2, "0");
  return months[month] + " " + day + ", " + year;
}

export function normalizeDateTime2(mydate) {
  if (mydate === null || mydate === undefined) {
    return null;
  }
  const utcplus8date = new Date(mydate).setHours(
    new Date(mydate).getHours() + 8
  );
  const date = new Date(utcplus8date);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  let year = date.getFullYear();
  let month = date.getMonth();
  let day = date.getDate().toString().padStart(2, "0");

  let hours = date.getHours();
  let minutes = date.getMinutes().toString().padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  const time = ((hours + 11) % 12) + 1 + ":" + minutes + " " + ampm;

  return months[month] + " " + day + ", " + year + "; " + time;
}

export function toYYYYMMDD(mydate) {
  const date = new Date(mydate);

  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate().toString().padStart(2, "0");
  return year + "-" + month + "-" + day;
}

export const getSlicedDay = (day) => {
  const weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const date = new Date(day);
  return weekday[date.getDay()].slice(0, 3).toUpperCase();
};

export const getMMDD = (day) => {
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const date = new Date(day);
  const mmdd = month[date.getMonth()].slice(0, 3) + " " + date.getDate();
  return mmdd;
};

export const getTime = (day) => {
  const date = new Date(day);
  // const hours = date.getHours();
  // const ampm = hours >= 12 ? "PM" : "AM";
  // const time =
  //   date.getHours() +
  //   ":" +
  //   String(date.getMinutes()).padStart(2, "0") +
  //   " " +
  //   ampm;
  return date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
};

export const formatDate = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

export const toISOStringWithTimezone = (date) => {
  const tzOffset = -date.getTimezoneOffset();
  const diff = tzOffset >= 0 ? "+" : "-";
  const pad = (n) => `${Math.floor(Math.abs(n))}`.padStart(2, "0");
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds()) +
    diff +
    pad(tzOffset / 60) +
    ":" +
    pad(tzOffset % 60)
  );
};
